import { useQuery } from "@tanstack/react-query";
import { fetchData } from "./../fetchData";
import { DEFAULT_STALE_TIME, DEFAULT_CACHE_TIME } from "../../../shared/constants";

export const useGetSchoolTeachersList = () => {
    return useQuery({
        queryKey: ["school/teachers"],
        queryFn: () => fetchData(`school/teachers`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};


export const useGetSchoolCoursesList = () => {
    return useQuery({
        queryKey: ["school/courses"],
        queryFn: () => fetchData(`school/courses`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};


export const useGetSkillToSchoolCourses = () => {
    return useQuery({
        queryKey: ["courses/skill-to-school"],
        queryFn: () => fetchData(`courses/skill-to-school`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useGetSkillFourTeachersCourses = () => {
    return useQuery({
        queryKey: ["courses/skill-for-teachers"],
        queryFn: () => fetchData(`courses/skill-for-teachers`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};





export const useGetAllSchool = () => {
    return useQuery({
        queryKey: ["school"],
        queryFn: () => fetchData(`school`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useGetSchoolsByPincode = (pincode) => {
  return useQuery({
    queryKey: ["schools-by-pincode", pincode],
    queryFn: () =>
      fetchData(`preschools/with-pincode?pincode=${pincode}`),
    enabled: !!pincode, // prevents API call when pincode is empty
    staleTime: DEFAULT_STALE_TIME,
    cacheTime: DEFAULT_CACHE_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};

